module.exports = __webpack_public_path__ + "assets/flags/mt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/mt.svg
// module id = 508
// module chunks = 0